import { render, staticRenderFns } from "./ReturnParam.vue?vue&type=template&id=33cb77fa&scoped=true&"
import script from "./ReturnParam.vue?vue&type=script&lang=js&"
export * from "./ReturnParam.vue?vue&type=script&lang=js&"
import style0 from "./ReturnParam.vue?vue&type=style&index=0&id=33cb77fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb77fa",
  null
  
)

export default component.exports